import "./SecHeader.css";

interface SecHeaderProps {
  title: React.ReactNode;
  lightMode?: boolean;
  sectionId?: string;
  iSize?: number;
}

const SecHeader: React.FC<SecHeaderProps> = ({
  title,
  lightMode = true,
  sectionId = "",
  iSize = 1, // default value
}) => {
  // Clamp value between 1–6 to stay valid HTML
  const level = Math.min(Math.max(iSize, 1), 6);

  const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements;
  // Base = 4rem for h1, scale down by 0.8 each step
  const scale = Math.pow(0.8, level - 1);
  const marginBottom = `${4 * scale}rem`;

  const formatTitle = (title: React.ReactNode): React.ReactNode => {
    if (typeof title !== "string") return title;

    const parts = title.split(/(TM|®|\(TM\))/g);

    return parts.map((part, index) => {
      if (part === "TM" || part === "(TM)") {
        return <sup key={index}>TM</sup>;
      }
      if (part === "®") {
        return <sup key={index}>®</sup>;
      }
      return part;
    });
  };

  return (
    <div
      id={sectionId}
      className={lightMode ? "section-header" : "section-header-dark"}
      style={{ marginBottom }}
    >
      <HeadingTag>{formatTitle(title)}</HeadingTag>
    </div>
  );
};

export default SecHeader;
